import React from 'react'
import LoginForm from './LoginForm'
import CloseIcon from "../../../Images//cancelicon.svg"


function LoginPopup({ dropdownData, onClose }) {
    return (
        <div className="popup-modal">
            <div className="popup-modal-content">
                <div className='popup-model-header'>
                    <p className="trouble-sigingIn">Having trouble signing in?</p>
                </div>
                <button type="button" className='popup-close-icon' onClick={onClose}>
                    <img className="familyclose-btn-width cursor-pointer" src={CloseIcon} alt="" />
                </button>
                <div style={{ width: "80%", margin: "auto" }}>
                    <LoginForm dropdownData={dropdownData} onClose={onClose}/>
                </div>
            </div>
        </div>
    )
}

export default LoginPopup